Carrousel

<template>
  <div class="clients-holder">

    <div class="container text-center">
      <h2 id="client-holder-heading">CASES DE SUCESSO</h2>

      <div class="row clients" @mouseover="swiperStopAutoplay" @mouseleave="swiperStartAutoplay">
        <swiper class="no-select" :autoplay="autoPlayConfig" :modules="modules" :autoHeight="true"
          :breakpoints="breakpoints" :loop="true" @swiper="onSwiper" grab-cursor-virtual>
          <swiper-slide v-for="client in clientsObj" :key="client.id">
            <div class="container-client">
              <div class="card-client">
                <div class="image">
                  <img class="img-holder" :src="require('@/assets/images/' + client.imgPath)">
                </div>
                <div class="content" style="">
                  <h5 class="content-header">{{ client.title }}</h5>
                  <div class="content-body">
                    <p class="content-body-text">
                      {{ fitDescriptionLenght(client.description) }}...
                    </p>
                    <span type="button" class="content-body-link" data-bs-toggle="modal"
                      data-bs-target="#modalDepoimentClient"
                      @click="showModalDepoiments(client.title, client.description, client.author, client.imgPath, client.authorRole)">
                      Ler mais
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>

        </swiper>

        <ClientModal :modalTitle="clickedClientTitle" :modalDescription="clickedClientDescription"
          :modalAuthor="clickedClientAuthor" :modalImg="clickedClientImg" :modalAuthorRole="clickedClientAuthorRole">
        </ClientModal>

      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { A11y, Autoplay } from 'swiper';
import ClientModal from './ClientModal.vue'

import 'swiper/css';
import 'swiper/css/autoplay';

export default {
  name: 'SectionClients',
  components: {
    Swiper,
    SwiperSlide,
    ClientModal,
  },
  data() {
    return {
      onShowMore: true,
      isHovering: false,
      clientsObj: [
        {
          id: "1",
          title: 'Ser Marisol',
          imgPath: "ser-marisol-logo.jpg",
          description: 'Ponto forte por termos fechado com a Bytecom e permanecer por mais de 5 anos, é o atendimento prestativo de todos na empresa junto com um sistema eficiente e intuitivo.',
          author: "Charles",
          authorRole: "Dono da Empresa"
        },
        {
          id: "2",
          title: 'Spessatto Sorvetes',
          imgPath: "logo-spessatto-sorvetes.jpg",
          description: 'Sou Rudinei da Spessatto Sorvetes. Nós da Spessato prezamos sempre por um trabalho de qualidade. Estamos com a parceria com a Bytecom, há mais de 10 anos. Sempre com um atendimento personalizado. Empresa que está sempre antenada nas evolução do mercado.',
          author: "Rudinei",
          authorRole: "Proprietário"
        },
        {
          id: "3",
          title: 'Güinther Frigorífico',
          imgPath: "logo-guinther-frigorifico.jpg",
          description: 'Trabalhar com a bytecom para nós do Frigorifico Güinther foi um sucesso. Além de todas as ferramentas que nos deu a possibilidade de criar novos processos, também são super abertos para o desenvolvimento e solução de nossos problemas "Exóticos" de uma empresa familiar.  O Atendimento deles é exepcional, recepcionamos eles aqui como se fossem da nossa familia, recomendo o sistema da bytecom para quem precisa desse atendimento mais proximo, ajudando na solução dos problemas e em alguns casos colocando a mão na massa, para entender realmente o que precisa ser feito.',
          author: "Eduardo",
          authorRole: "Proprietário"
        },
        {
          id: "4",
          title: 'Restaurante Boa Vista',
          imgPath: "boa-vista-logo.jpg",
          description: 'Gostaria de expressar minha gratidão e reconhecimento pelo excelente trabalho que você e sua equipe fizeram para nos fornecer serviços de tecnologia de alta qualidade. Sua equipe sempre se esforçou para entender nossas necessidades e foi além das nossas expectativas ao entregar soluções personalizadas para nossa empresa. Estamos extremamente satisfeitos com o trabalho que vocês fizeram e os resultados que foram alcançados. A maneira como vocês lidam com nossas necessidades e questões é extremamente profissional e dedicada.',
          author: "",
          authorRole: "Rodrigo"
        },
        {
          id: "5",
          title: 'Luvisa',
          imgPath: "luvisa-logo.png",
          description: 'O que eu mais gostei sobre a parceria com sua empresa é a comunicação eficaz e transparente que tivemos ao longo do projeto. Foi muito útil para nós receber atualizações frequentes sobre o progresso do projeto e ter a oportunidade de fornecer feedback regularmente. Sua equipe sempre esteve disponível para responder nossas dúvidas e preocupações de maneira oportuna e profissional.',
          author: "Weber",
          authorRole: "Proprietário"
        },
      ],
      clickedClientDescription: "",
      clickedClientTitle: "",
      clickedClientAuthor: "",
      clickedClientImg: "",
      clickedClientAuthorRole: "",
      swiper: null,
    }
  },
  methods: {
    showModalDepoiments(title, description, author, imgPath, authorRole) {
      this.clickedClientDescription = description
      this.clickedClientTitle = title
      this.clickedClientAuthor = author
      this.clickedClientImg = imgPath
      this.clickedClientAuthorRole = authorRole
    },

    fitDescriptionLenght(clientDescription) {
      if (screen.width <= 1399 && screen.width >= 1201)
        return clientDescription.slice(0, 185)

      if (screen.width < 1200)
        return clientDescription.slice(0, 140)

      return clientDescription.slice(0, 421)
    },

    onSwiper(swiper) {
      this.swiper = swiper;
    },

    swiperStopAutoplay() {
      this.swiper.autoplay.stop()
    },

    swiperStartAutoplay() {
      this.swiper.autoplay.start()
    }
  },
  setup() {
    return {
      modules: [A11y, Autoplay],
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        500: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: -20
        },
        1300: {
          slidesPerView: 3,
          spaceBetween: 0
        }
      },
      autoPlayConfig: {
        "delay": 3000,
        "disableOnInteraction": true
      }
    };
  },
}
</script>

<style>
.clients-holder {
  background-color: #ececec;
  padding: 70px 0;
  font-family: Montserrat Regular;
}

#client-holder-heading {
  text-transform: uppercase;
  margin-bottom: 70px;
  font-family: Montserrat Medium;
  filter: drop-shadow(2px 2px rgba(122, 121, 121, 0.575));
  color: #323232;
  font-weight: 600;
}

.clients {
  margin: 0 7%;
}

.no-select {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.swiper {
  padding: 40px 0;
  height: 450px;
}

.content-header {
  font-family: Montserrat Medium;
  color: #323232;
}

.content-body .content-body-text {
  font-size: 0.9rem;
  text-align: left;
  line-height: 1rem;
  color: #323232;

  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 11;
  -webkit-box-orient: vertical;

  margin-bottom: 0;
}

.content-body span {
  font-size: 0.9rem;
  text-align: left;
  line-height: 1rem;
  color: #0d6efd;
  cursor: pointer;
}

.content-body .content-body-link {
  /* color: #0d6efd;
  cursor: pointer; */
}

.card-client {
  position: relative;
  height: 175px;
  background-color: #fff;
  margin: 30px 10px;
  padding: 20px 15px;

  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
  transition: 0.3s ease-in-out;
  border-radius: 15px;
}

.card-client:hover {
  height: 320px;
  cursor: pointer;
}

.swiper-slide-next .card-client {
  height: 320px;
}

.swiper-slide-next .card-client .content {
  visibility: visible;
  opacity: 1;
  transition-delay: 0.2s;
}

.container-client {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
}

.card-client .image {
  position: relative;
  width: 160px;
  height: 160px;

  top: -40%;
  left: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.card-client .image img {
  max-width: 100%;
  border-radius: 15px;
}

.card-client .content {
  position: relative;
  top: -140px;
  padding: 40px 15px;
  color: #111;
  text-align: center;

  visibility: hidden;
  opacity: 0;
  transition: 0.3s ease-in-out;
}

.card-client:hover .content {
  padding-top: 40px;
  visibility: visible;
  opacity: 1;
  transition-delay: 0.2s;

  height: 100%;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
}

.swiper-button-prev,
.swiper-button-next {
  top: 41% !important;
  color: #323232;
}

@media (max-width: 1000px) {
  .swiper-slide-active .card-client {
    height: 320px;
  }

  .swiper-slide-active .card-client .content {
    visibility: visible;
    opacity: 1;
    transition-delay: 0.2s;
  }
}
</style>